import React from 'react'

export default (props)=>
    <svg {...props} width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.00354 19C10.8715 19 14.0071 14.7467 14.0071 9.5C14.0071 4.25329 10.8715 0 7.00354 0C3.13559 0 0 4.25329 0 9.5C0 14.7467 3.13559 19 7.00354 19ZM7 12C9.48528 12 11.5 9.98528 11.5 7.5C11.5 5.01472 9.48528 3 7 3C4.51472 3 2.5 5.01472 2.5 7.5C2.5 9.98528 4.51472 12 7 12Z" fill="white"/>
    </svg>
